export default __webpack_public_path__ + "static/media/volunteer.58a07176.jpg";